var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3100",
    "data-name": "Gruppe 3100",
    transform: "translate(-44.768 -787.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3095",
    "data-name": "Gruppe 3095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2220",
    "data-name": "Pfad 2220",
    d: "M5,9.585a.707.707,0,0,1-.724-.724V1.449H1.449V8.86A.725.725,0,1,1,0,8.86V.725A.725.725,0,0,1,.725,0H5a.725.725,0,0,1,.725.725V8.86A.7.7,0,0,1,5,9.585Z",
    transform: "translate(58.545 798.459)",
    fill: "#238cb9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2221",
    "data-name": "Pfad 2221",
    d: "M.725,22.906A.725.725,0,0,1,0,22.181V8a.73.73,0,0,1,.273-.594L9.371.161a.713.713,0,0,1,.9,0l9.1,7.269a.754.754,0,0,1,.267.487.725.725,0,0,1-.719.808.748.748,0,0,1-.457-.16L9.823,1.634,1.449,8.344V21.457H18.2V11.9a.725.725,0,0,1,1.449,0v10.28a.725.725,0,0,1-.725.725Z",
    transform: "translate(51.585 787.193)",
    fill: "#238cb9",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.75c363ff0a06985b1c93b54aace1788b.svg";
export { ForwardRef as ReactComponent };